<template>
    <div v-show="show" data-type="Providers">
        <label class="block mb-2">{{field.label}}<span class="text-bold inline-block ml-2" v-if="field.isRequired" title="This field is required" aria-hidden="true">*</span></label>

        <div class="flex flex-wrap -mx-2">
            <div v-if="!staff.length" class="px-2">There are no providers to select from.</div>
            <div
                v-else
                v-for="(choice, choice_key) in staff"
                :key="choice_key"
                class="w-1/2 md:w-1/4 mb-4 px-2"
            >
                <div
                    class="border-2 border-blue-500 border-solid hover:shadow-md p-4 h-full cursor-pointer flex flex-col justify-center items-center"
                    :class="{'border-black': $store.state.data.provider == choice.ID, 'border-secondary-nonbinary-300': $store.state.data.provider != choice.ID}"
                >
                    <input
                        tabindex="0"
                        :id="`field_${field.id}_${choice_key}`"
                        :type="types[field.type]"
                        :name="field.id"
                        :value="choice.value"
                        v-model="fields[field.id]"
                        :required="field.isRequired"
                        class="hidden"
                        :class="field.cssClass"
                    />
                    <label
                        :for="`field_${field.id}_${choice_key}`"
                        class="font-medium"
                    >
                        <figure>
                            <img 
                                :src="choice.image"
                                alt="choice.post_title"
                            />
                            <figcaption class="text-center text-xl" v-text="choice.post_title"></figcaption>
                        </figure>
                    </label>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["field","fields"],
    computed: {
        staff() {
            if (
                typeof window.departments[this.$store.state.data.service] !=
                "undefined"
            ) {
                return window.departments[this.$store.state.data.service][
                    "staff"
                ];
            }

            return [];
        },
        show() {
            if (
                this.field.conditionalLogic != "" &&
                this.field.conditionalLogic.rules.length
            ) {
                let s = false;

                for (
                    let i = 0;
                    i < this.field.conditionalLogic.rules.length;
                    i++
                ) {
                    let f = this.$store.state.steps[
                        this.$store.state.step
                    ].fields.find(
                        (e) =>
                            e.id == this.field.conditionalLogic.rules[i].fieldId
                    );

                    if ( f != undefined) {
                        let name = f.id;

                        if (
                            this.$store.state.data[name] ==
                            this.field.conditionalLogic.rules[i].value
                        ) {
                            s = true;
                        }
                    }
                }

                return s;
            }

            return true;
        },
    },
};
</script>